'use client';

import { c as _c } from "react/compiler-runtime";
import Gradient_1 from '@images/gradients/gradient_1.webp';
import Gradient_1_mob from '@images/gradients/gradient_1_mob.webp';
import Bgr1 from '@images/renders/infrastructure_images/Infra_Desktop_Webp/1.webp';
import Bgr1_Mob from '@images/renders/infrastructure_images/Infra_Mobile_Webp/1.webp';
import { animated, useSpring } from '@react-spring/web';
import NextImage from 'next/image';
import { useLayoutEffect, useRef, useState } from 'react';
import ParallaxMedia from '../../parallax-media/ParallaxMedia';
import style from './FirstScreenInfra.module.scss';
function FirstScreenInfra(t0) {
  const $ = _c(37);
  const {
    isMobile
  } = t0;
  const firstContainerRef = useRef();
  const [toggle, setToggle] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setTimeout(() => {
        setToggle(true);
      }, 200);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useLayoutEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 750,
      mass: 1,
      tension: 280,
      friction: 120
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = !toggle ? 0 : 1;
  const t5 = !toggle ? "100%" : "0%";
  let t6;
  if ($[3] !== t4 || $[4] !== t5) {
    t6 = {
      config: t3,
      opacity: t4,
      y: t5,
      delay: 1000
    };
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const animatedStyle = useSpring(t6);
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      duration: 750,
      mass: 1,
      tension: 280,
      friction: 120
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = !toggle ? 0 : 1;
  const t9 = !toggle ? "30%" : "0%";
  let t10;
  if ($[7] !== t8 || $[8] !== t9) {
    t10 = {
      config: t7,
      opacity: t8,
      y: t9,
      delay: 1000
    };
    $[7] = t8;
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const animatedStyle2 = useSpring(t10);
  let t11;
  if ($[10] !== isMobile) {
    t11 = !isMobile && <p className={style.seoText}>Архитектурный проект в окружении парков</p>;
    $[10] = isMobile;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== isMobile) {
    t12 = isMobile && <div className={style.firstScreenTitleMob}><p>Продуманный мир для детей и для<br />взрослых</p></div>;
    $[12] = isMobile;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== isMobile) {
    t13 = !isMobile && <ParallaxMedia src={Bgr1} src375={Bgr1_Mob} name="bgr_1" className={style.bgStyle} imagePlug={Bgr1} height="100dvh" />;
    $[14] = isMobile;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== isMobile) {
    t14 = !isMobile && <NextImage loading="lazy" decoding="defer" src={!isMobile ? Gradient_1 : Gradient_1_mob} alt="gradient" className={style.firstScreenGradient} fill={true} />;
    $[16] = isMobile;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== isMobile) {
    t15 = isMobile && <div className={style.firstScreenImgMob}><ParallaxMedia src={Bgr1} src375={Bgr1_Mob} alt="picture" imagePlug={Bgr1} /></div>;
    $[18] = isMobile;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== isMobile) {
    t16 = isMobile && <div className={style.firstScreenBoxTextMob} data-scroll={true} data-scroll-speed="0.5" data-scroll-target="#about"><p>Собственные <br />школа и детский сад</p><p>IV кв 2028 год</p><p>Детские площадки <br />и спортивные площадки</p><p>Рестораны <br />и магазины у дома</p></div>;
    $[20] = isMobile;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== animatedStyle2 || $[23] !== isMobile) {
    t17 = !isMobile && <div className={style.firstScreenAnimText}><animated.div style={animatedStyle2} className={style.firstScreenBoxTitle}><p>Продуманный мир</p><p>для детей </p><p>и взрослых</p></animated.div></div>;
    $[22] = animatedStyle2;
    $[23] = isMobile;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== animatedStyle || $[26] !== isMobile) {
    t18 = !isMobile && <animated.div style={animatedStyle} className={style.firstScreenBoxText}><div className={style.firstScreenText}>Собственные <br /> школа и детский сад<p>IV квартал 2028 год</p></div><div className={style.firstScreenText}>Детские и спортивные площадки</div><div className={style.firstScreenText}>Кафе <br /> и магазины у дома</div></animated.div>;
    $[25] = animatedStyle;
    $[26] = isMobile;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== t11 || $[29] !== t12 || $[30] !== t13 || $[31] !== t14 || $[32] !== t15 || $[33] !== t16 || $[34] !== t17 || $[35] !== t18) {
    t19 = <div className={style.firstScreenContainer} ref={firstContainerRef} data-scroll-speed="0.5" id="about">{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}</div>;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
    $[34] = t17;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  return t19;
}
export default FirstScreenInfra;